<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">机构管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">机构管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>标签名称
					<el-input size="small" placeholder="标签名称" clearable v-model.trim="filter.orgName" @keyup.enter.native="handleFilter(1)"></el-input>
				</label>
				<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增机构</el-button>
				
				<!-- <el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
				</el-popconfirm> -->
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="orgName" label="机构名称" ></el-table-column>
				<el-table-column prop="abbreviation" label="机构简称" ></el-table-column>
				<el-table-column prop="type" label="机构级别" width="200">
					<template slot-scope="scope">
						<span v-if="scope.row.type === '1'">医院</span>
						<span v-else-if="scope.row.type === '2'">乡镇卫生院</span>
						<span v-else>社区医院</span>
					</template>
				</el-table-column>
				<el-table-column prop="reviserName" label="更新人" width="200"></el-table-column>
				<el-table-column prop="date" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip> -->
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改机构' : '新增机构'" width="530px" center :visible.sync="dlg.active">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">

				<el-form-item label="机构名称" prop="orgName">
					<el-input v-model="form.orgName"></el-input>
				</el-form-item>
				
				<el-form-item label="机构类型" prop="type">
					<el-select filterable clearable v-model="form.type" placeholder="请选择">
						<el-option label="医院" value="1"></el-option>
						<el-option label="乡镇卫生院" value="2"></el-option>
						<el-option label="社区医院" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="机构简称" prop="abbreviation">
					<el-input v-model="form.abbreviation"></el-input>
				</el-form-item>
				<el-form-item label="机构编码" prop="orgCode">
					<el-input v-model="form.orgCode"></el-input>
				</el-form-item>
				<div style="margin-bottom: 20px; font-size: 14px; text-align: center;">疾病管理PAD</div>

				<el-form-item label="接口IP" prop="padIp">
					<el-input v-model="form.padIp"></el-input>
				</el-form-item>
				
				<el-form-item label="接口端口号" prop="padPort">
					<el-input v-model="form.padPort"></el-input>
				</el-form-item>	


				<div style="margin-bottom: 20px; font-size: 14px; text-align: center;">微信小程序</div>

				<el-form-item label="接口IP" prop="wxIp">
					<el-input v-model="form.wxIp"></el-input>
				</el-form-item>
				
				<el-form-item label="接口端口号" prop="wxPort">
					<el-input v-model="form.wxPort"></el-input>
				</el-form-item>				

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		
		
  </div>
	
			
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					name: {required: true, message: '请输入模板名', trigger: 'blur'},
					departmentId: {required: true, message: '请选择科室', trigger: 'change'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				departmentId:'',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				orgName: '',
				type: '',
				padIp: '',
				padPort: '',
				wxIp: '',
				wxPort: '',
				abbreviation:'',
				orgCode:''
			},
			deptList: []
		}
	},
	created() {
		this.loadList();
		// 获取 科室下拉
		api.getDeptDropdown({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		})
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getSysOrgList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		showDlg(item) {
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(async ()=>{
					let res = await api.getSysOrg(item.id);
					if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
					this.form = res.data;
					// if (this.form.icds?.length > 0) {
					// 	this.form.icds = this.form.icds.map(item=> item.icdCode);
					// }
					this.$refs['form'].resetFields();				

					// this.$refs['form'].resetFields();
					// this.form.id = item.id;
					// this.form.name = item.name;
					// this.form.departmentId = item.departmentId;
					// this.$refs['tree'].setCheckedKeys(item.regionId);
				});
			} else {
				this.form.id = 0;
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
				});
			}
		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveForm() {
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					if (this.form.id > 0) {
						res = await api.editSysOrg(this.form);
					} else {
						res = await api.addSysOrg(this.form);
					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			res = await api.delSysOrg(item.id);
			// if (item && item.id > 0) {
			// 	res = await api.delSysOrg(item.id);
			// } else {
			// 	// 批量删除
			// 	if (this.multipleSelection.length == 0) {
			// 		this.isLoading = false;
			// 		return this.$message.warning('未选择任何数据');
			// 	}
			// 	res = await api.delScheduleTemplate({ids: this.multipleSelection.join(',')});
			// }
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
